import { render, staticRenderFns } from "./chart08.vue?vue&type=template&id=58b7d618"
import script from "./chart08.vue?vue&type=script&lang=js"
export * from "./chart08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports